import React from 'react';

const Entertainment = () => {
  return (
    <div className='container mt-4 pb-6'>
      <div className='mt-5 row mx-0'>
        <div className='col-md-6 px-0 d-flex align-items-center'>
          <span className='page-title'>Entertainment</span>
        </div>
      </div>
      <div className='row mx-2 d-flex mt-4'>
        <div className='card shadow'></div>
      </div>
    </div>
  );
};

export default Entertainment;
